import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import "./SortScreenIcon.scss"

interface props {
  ascending: boolean;
  descending: boolean;
}

export default function SortScreenIcon({ascending, descending} : props) {
  return (
    <div className="sort-screen-icon">
      <CaretUpOutlined style={{color: ascending ? '#e42436' : '#333'}}/>
      <CaretDownOutlined style={{color: descending ? '#e42436' : '#333'}}/>
    </div>
  );
}
